export const roles = [
    "belgium",
    "netherlands",
    "luxembourg"
];
